// Festival PDFs linked from the dancer dashboard.

export const IABF_GUIDEBOOK_PDF_URL =
  'https://storage.googleapis.com/broche-ballet-online.appspot.com/iabf-resources/guidebook-2027.pdf'

export const IABF_POSING_GUIDE_PDF_URL =
  'https://storage.googleapis.com/broche-ballet-online.appspot.com/iabf-resources/posing-guide-2027.pdf'
